import React from "react";

class Tab extends React.Component {
  render() {
    const active = this.props.id === this.props.activeTab ? "active" : "";

    return (
      <div
        id={`tab-${this.props.id}`}
        className={`tab tab--textfield tabs__layer--${this.props.id} ${active}`}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Tab;
